import clsx from "clsx";
import type React from "react";

interface OptionalTileProps<K = HTMLButtonElement>
	extends React.PropsWithChildren,
		React.DetailedHTMLProps<React.ButtonHTMLAttributes<K>, K> {
	color?: "action" | "primary" | "secondary";
	componentStyle?: "default" | "inverted";
}

interface RequiredTileProps {
	label: string | TrustedHTML;
	value: string;
}

export type CommonTileProps<K = HTMLButtonElement> = OptionalTileProps<K> &
	RequiredTileProps;

export function createTileClassNames(
	{ className, color, componentStyle }: OptionalTileProps,
	variant: "default" | "stacked",
) {
	return clsx(
		{
			tile: true,
			"tile--is-default": !variant || variant === "default",
			"tile--is-stacked": variant === "stacked",
			"tile--is-action": color === "action" || !color,
			"tile--is-primary": color === "primary",
			"tile--is-secondary": color === "secondary",
			"tile--is-inverted": componentStyle === "inverted",
		},
		className,
	);
}
